<template>
  <div class="contact-page" id="contact">
    <section class="contact-hero">
      <div class="hero-mask">
        <h1>{{ $t('contactUs.heroTitle') }}</h1>
        <p>{{ $t('contactUs.heroSubtitle') }}</p>
      </div>
    </section>

    <section class="bread-bar-wrapper">
      <div class="bread-bar section">
        <div class="left">
          <img class="icon" src="@/static/image/about6.png" alt="home" />
          <router-link to="/" class="item">{{ $t('contactUs.breadcrumbHome') }}</router-link>
          <span class="item sep">&gt;</span>
          <span class="item active">{{ $t('contactUs.breadcrumbCurrent') }}</span>
        </div>

        <div class="right">
          <a
            v-for="item in anchorMenus"
            :key="item.key"
            class="item"
            :class="{ active: activeAnchor === item.key }"
            href="javascript:void(0)"
            @click="scrollToAnchor(item.key)"
          >
            {{ $t(item.labelKey) }}
            <span class="border"></span>
          </a>
        </div>
      </div>
    </section>

    <section class="company-wrapper section" ref="company">
      <div class="poetry">
        <p>{{ $t('contactUs.poetry1') }}</p>
        <p>{{ $t('contactUs.poetry2') }}</p>
        <p>{{ $t('contactUs.poetry3') }}</p>
      </div>

      <article class="company-item" v-for="(item, index) in companies" :key="index" :id="`com${index + 1}`">
        <div class="fl1">
          <div class="left">{{ $t(item.nameKey) }}</div>
          <div class="right">{{ $t(item.descKey) }}</div>
        </div>

        <div class="fl2">
          <img :src="item.image" :alt="$t(item.nameKey)" />
        </div>

        <div class="fl3">{{ $t('contactUs.manager') }}{{ item.manager }} {{ $t('contactUs.phone') }}{{ item.phone }}</div>
      </article>
    </section>

    <section class="map-section section" ref="map">
      <div class="map-title">{{ $t('contactUs.mapTitle') }}</div>
      <div id="contactMap" class="map-container"></div>
    </section>

    <section ref="footer">
      <SiteFooter />
    </section>
  </div>
</template>

<script>
import SiteFooter from '@/components/layout/newHome/sections/SiteFooter.vue'

const AMAP_KEY = 'b67bed146b280e4a407e3393f93c84f4'
const AMAP_JS_URL = `https://webapi.amap.com/maps?v=1.4.15&key=${AMAP_KEY}&plugin=AMap.ControlBar`

export default {
  name: 'ContactUs',
  components: {
    SiteFooter
  },
  data() {
    return {
      map: null,
      activeAnchor: 'company',
      anchorMenus: [
        { key: 'map', labelKey: 'contactUs.anchorMap' },
        { key: 'company', labelKey: 'contactUs.anchorCompany' },
        { key: 'footer', labelKey: 'contactUs.anchorMessage' }
      ],
      companies: [
        {
          nameKey: 'contactUs.companies.c1Name',
          descKey: 'contactUs.companies.c1Desc',
          image: require('@/static/image/contact1.png'),
          manager: '楚雅琼',
          phone: '17352652561',
          pos: [112.942873, 27.849129]
        },
        {
          nameKey: 'contactUs.companies.c2Name',
          descKey: 'contactUs.companies.c2Desc',
          image: require('@/static/image/contact6.png'),
          manager: '彭芳',
          phone: '18008449190',
          pos: [112.988998, 28.074679]
        },
        {
          nameKey: 'contactUs.companies.c3Name',
          descKey: 'contactUs.companies.c3Desc',
          image: require('@/static/image/contact5.png'),
          manager: '傅树',
          phone: '15526488804',
          pos: [112.988449, 28.075242]
        },
        {
          nameKey: 'contactUs.companies.c4Name',
          descKey: 'contactUs.companies.c4Desc',
          image: require('@/static/image/contact3.png'),
          manager: '严寒',
          phone: '16673232666',
          pos: [112.947017, 27.782168]
        },
        {
          nameKey: 'contactUs.companies.c5Name',
          descKey: 'contactUs.companies.c5Desc',
          image: require('@/static/image/contact2.png'),
          manager: '熊国平',
          phone: '15526488804',
          pos: [112.922343, 27.817307]
        },
        {
          nameKey: 'contactUs.companies.c6Name',
          descKey: 'contactUs.companies.c6Desc',
          image: require('@/static/image/contact4.png'),
          manager: '李志强',
          phone: '18073237478',
          pos: [112.92217, 27.816723]
        },
        {
          nameKey: 'contactUs.companies.c7Name',
          descKey: 'contactUs.companies.c7Desc',
          image: require('@/static/image/contact7.png'),
          manager: '毛新花',
          phone: '0731-55579228',
          pos: [112.922343, 27.817307]
        },
        {
          nameKey: 'contactUs.companies.c8Name',
          descKey: 'contactUs.companies.c8Desc',
          image: require('@/static/image/contact8.png'),
          manager: '罗首魁',
          phone: '13875271167',
          pos: [112.54149, 27.74019]
        },
        {
          nameKey: 'contactUs.companies.c9Name',
          descKey: 'contactUs.companies.c9Desc',
          image: require('@/static/image/contact9.png'),
          manager: '何恒毅',
          phone: '18627310850',
          pos: [112.988998, 28.074679]
        },
        {
          nameKey: 'contactUs.companies.c10Name',
          descKey: 'contactUs.companies.c10Desc',
          image: require('@/static/image/contact10.png'),
          manager: '刘梦达',
          phone: '18969374033',
          pos: [112.988998, 28.074679]
        },
        {
          nameKey: 'contactUs.companies.c11Name',
          descKey: 'contactUs.companies.c11Desc',
          image: require('@/static/image/contact11.png'),
          manager: '严寒',
          phone: '16673232666',
          pos: [112.988998, 28.074679]
        },
        {
          nameKey: 'contactUs.companies.c12Name',
          descKey: 'contactUs.companies.c12Desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/fb82bf28-f940-4ad7-8214-ae3b4c24c468.png',
          manager: '马瑛',
          phone: '13973274467',
          pos: [112.988449, 28.075242]
        }
      ]
    }
  },
  mounted() {
    this.applyHashAnchor()
    this.initMap()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('hashchange', this.applyHashAnchor)
    this.handleScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('hashchange', this.applyHashAnchor)
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  },
  methods: {
    async initMap() {
      try {
        if (!window['AMap']) {
          await this.loadScript(AMAP_JS_URL)
        }
        this.$nextTick(() => {
          this.createMap()
        })
      } catch (e) {
        // 方便线上排查地图异常
        console.error('[ContactUs] AMap init failed:', e)
      }
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        if (window['AMap']) {
          resolve()
          return
        }

        // 兼容页面里可能已注入了不同 query 参数的高德脚本
        const existed = Array.from(document.querySelectorAll('script[src]')).find(item =>
          item.src.includes('webapi.amap.com/maps')
        )

        const waitAMapReady = () => {
          let count = 0
          const timer = setInterval(() => {
            count += 1
            if (window['AMap']) {
              clearInterval(timer)
              resolve()
            }
            if (count > 50) {
              clearInterval(timer)
              reject(new Error('AMap load timeout'))
            }
          }, 100)
        }

        if (existed) {
          existed.addEventListener('load', waitAMapReady)
          existed.addEventListener('error', reject)
          waitAMapReady()
          return
        }

        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.onload = waitAMapReady
        script.onerror = reject
        document.body.appendChild(script)
      })
    },
    createMap() {
      if (!window['AMap'] || this.map) return
      this.map = new window['AMap'].Map('contactMap', {
        resizeEnable: true,
        center: [112.913819, 27.862591],
        zoom: 8
      })
      this.map.plugin(['AMap.ControlBar'], () => {
        const controlBar = new window['AMap'].ControlBar({
          position: { top: '10px', left: '10px' }
        })
        this.map.addControl(controlBar)
      })

      const markers = this.companies
        .filter(item => Array.isArray(item.pos))
        .map(item => {
          const companyName = this.$t(item.nameKey)
          const marker = new window['AMap'].Marker({ position: item.pos, title: companyName })
          const info = `${companyName}<br/>${this.$t('contactUs.manager')}${item.manager}<br/>${this.$t('contactUs.phone')}${item.phone}`
          marker.on('click', () => {
            const infoWindow = new window['AMap'].InfoWindow({
              content: `<div style="padding:6px 8px;line-height:1.8;">${info}</div>`,
              offset: new window['AMap'].Pixel(0, -30)
            })
            infoWindow.open(this.map, marker.getPosition())
          })
          return marker
        })
      this.map.add(markers)
      this.map.setFitView(markers)
    },
    scrollToAnchor(key, behavior = 'smooth') {
      const companyMatch = /^com(\d+)$/.exec(key || '')
      const el = companyMatch ? document.getElementById(key) : this.$refs[key]
      if (!el) return
      this.activeAnchor = companyMatch ? 'company' : key

      const headerOffset = 150
      const rectTop = el.getBoundingClientRect().top
      const targetTop = rectTop + window.pageYOffset - headerOffset
      window.scrollTo({ top: Math.max(targetTop, 0), behavior })
      window.history.replaceState(null, '', `#${key}`)
    },
    applyHashAnchor() {
      const hash = (window.location.hash || '').replace('#', '')
      if (!hash) return
      const companyMatch = /^com(\d+)$/.exec(hash)
      if (companyMatch) {
        const index = Number(companyMatch[1])
        if (index >= 1 && index <= this.companies.length) {
          this.$nextTick(() => {
            this.scrollToAnchor(hash, 'auto')
            setTimeout(() => this.scrollToAnchor(hash, 'smooth'), 120)
          })
          return
        }
      }
      if (!['map', 'company', 'footer'].includes(hash)) return
      this.$nextTick(() => this.scrollToAnchor(hash))
    },
    handleScroll() {
      const keys = ['map', 'company', 'footer']
      const offsets = keys
        .map(key => {
          const el = this.$refs[key]
          if (!el) return null
          return { key, abs: Math.abs(el.getBoundingClientRect().top - 120) }
        })
        .filter(Boolean)
      if (!offsets.length) return
      offsets.sort((a, b) => a.abs - b.abs)
      this.activeAnchor = offsets[0].key
    }
  }
}
</script>

<style scoped>
.contact-page { background: #f7f8fa; padding-top: 80px; }
.section { width: 1200px; margin: 0 auto; }
.contact-hero { height: 300px; background: url('~@/static/image/contact-banner.png') center center / cover no-repeat; }
.hero-mask { width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; color: #fff; background: rgba(20, 42, 88, 0.18); }
.hero-mask h1 { font-size: 50px; line-height: 1.1; margin: 0; letter-spacing: 2px; }
.hero-mask p { margin: 14px 0 0; font-size: 30px; letter-spacing: 2px;color: #fff; }
.bread-bar-wrapper { height: 62px; background: #ffffff; border-bottom: 1px solid #eef1f5; }
.bread-bar { display: flex; height: 100%; justify-content: space-between; align-items: center; }
.bread-bar .left { display: flex; align-items: center; font-size: 14px; color: #666; }
.bread-bar .left .icon { width: 17px; margin-right: 10px; }
.bread-bar .left .item { margin-right: 8px; color: #333; text-decoration: none; }
.bread-bar .left .sep { color: #8d96a3; }
.bread-bar .left .active { color: #1c51a3; }
.bread-bar .right { display: flex; align-items: center; height: 100%; }
.bread-bar .right .item { width: 110px; text-align: center; color: #4a5568; text-decoration: none; position: relative; font-size: 16px; }
.bread-bar .right .item .border { position: absolute; bottom: -22px; left: 50%; transform: translateX(-50%); width: 0; height: 3px; background: #1c51a3; transition: width 0.25s; }
.bread-bar .right .item.active { color: #1c51a3; }
.bread-bar .right .item.active .border { width: 92px; }
.company-wrapper { padding: 60px 0 24px; }
.poetry { text-align: center; color: #5a6270; font-size: 40px; line-height: 1.8; margin-bottom: 42px; }
.company-item { background: #fff; border-radius: 10px; padding: 26px; margin-bottom: 26px; box-shadow: 0 10px 24px rgba(26, 57, 110, 0.06); }
.company-item .fl1 { display: flex; align-items: flex-start; margin-bottom: 18px; }
.company-item .fl1 .left { width: 260px; flex-shrink: 0; color: #26313f; font-size: 18px; font-weight: 700; line-height: 1.4; margin-right: 30px; }
.company-item .fl1 .right { color: #4f5a66; line-height: 1.95; font-size: 14px;text-align: left; }
.company-item .fl2 { border-radius: 8px; overflow: hidden; margin-bottom: 18px; }
.company-item .fl2 img { width: 100%; display: block; }
.company-item .fl3 { color: #1c51a3; font-size: 14px; font-weight: 600; }
.map-section { margin-top: 28px; margin-bottom: 40px; background: #fff; border-radius: 10px; padding: 26px; box-shadow: 0 10px 24px rgba(26, 57, 110, 0.06); }
.map-title { color: #26313f; font-size: 18px; font-weight: 700; margin-bottom: 20px; }
.map-container { width: 100%; height: 560px; border-radius: 8px; overflow: hidden; }
</style>

